export default "/images/820c1766db97c3a39aaeb51264ed3b45.avif";